/**
 * @generated SignedSource<<0a3e6751696d2bcc86174a27d403a1cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCryptoAddressInput = {
  networkId: string;
};
export type CreateCryptoAddressMutation$variables = {
  input?: CreateCryptoAddressInput | null | undefined;
};
export type CreateCryptoAddressMutation$data = {
  readonly createCryptoAddress: {
    readonly address: string;
    readonly createdAt: TimeScalar | null | undefined;
    readonly destinationTag: string | null | undefined;
    readonly hostName: string | null | undefined;
    readonly id: string;
    readonly ownerLegalName: string | null | undefined;
  } | null | undefined;
};
export type CreateCryptoAddressMutation = {
  response: CreateCryptoAddressMutation$data;
  variables: CreateCryptoAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CryptoAddress",
    "kind": "LinkedField",
    "name": "createCryptoAddress",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "destinationTag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerLegalName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hostName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCryptoAddressMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCryptoAddressMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e54710cd46dba566aa4074ecb7e92d8d",
    "id": null,
    "metadata": {},
    "name": "CreateCryptoAddressMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCryptoAddressMutation(\n  $input: CreateCryptoAddressInput\n) {\n  createCryptoAddress(input: $input) {\n    id\n    address\n    createdAt\n    destinationTag\n    ownerLegalName\n    hostName\n  }\n}\n"
  }
};
})();

(node as any).hash = "39b442cc829f21dcbe3be783ae130706";

export default node;
